"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lifecycle = require("recompose/lifecycle");

var _lifecycle2 = _interopRequireDefault(_lifecycle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (willReceiveProps) {
  return (0, _lifecycle2.default)({
    componentWillMount: function componentWillMount() {
      return this.componentWillReceiveProps(this.props);
    },
    componentWillReceiveProps: function componentWillReceiveProps(props) {
      return willReceiveProps(props, this.props);
    }
  });
};
// recompose.withProps, but support redirects without a warning.
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL3V0aWwvd2lsbFJlY2VpdmVQcm9wcy5qcyJdLCJuYW1lcyI6WyJ3aWxsUmVjZWl2ZVByb3BzIiwiY29tcG9uZW50V2lsbE1vdW50IiwiY29tcG9uZW50V2lsbFJlY2VpdmVQcm9wcyIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFFQTs7Ozs7O2tCQUVlLFVBQUNBLGdCQUFEO0FBQUEsU0FDYix5QkFBVTtBQUNSQyxzQkFEUSxnQ0FDYTtBQUNuQixhQUFPLEtBQUtDLHlCQUFMLENBQStCLEtBQUtDLEtBQXBDLENBQVA7QUFDRCxLQUhPO0FBSVJELDZCQUpRLHFDQUlrQkMsS0FKbEIsRUFJeUI7QUFDL0IsYUFBT0gsaUJBQWlCRyxLQUFqQixFQUF3QixLQUFLQSxLQUE3QixDQUFQO0FBQ0Q7QUFOTyxHQUFWLENBRGE7QUFBQSxDO0FBSGYiLCJmaWxlIjoid2lsbFJlY2VpdmVQcm9wcy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vLyByZWNvbXBvc2Uud2l0aFByb3BzLCBidXQgc3VwcG9ydCByZWRpcmVjdHMgd2l0aG91dCBhIHdhcm5pbmcuXG5pbXBvcnQgbGlmZWN5Y2xlIGZyb20gXCJyZWNvbXBvc2UvbGlmZWN5Y2xlXCJcblxuZXhwb3J0IGRlZmF1bHQgKHdpbGxSZWNlaXZlUHJvcHM6IEZ1bmN0aW9uKSA9PlxuICBsaWZlY3ljbGUoe1xuICAgIGNvbXBvbmVudFdpbGxNb3VudCgpIHtcbiAgICAgIHJldHVybiB0aGlzLmNvbXBvbmVudFdpbGxSZWNlaXZlUHJvcHModGhpcy5wcm9wcylcbiAgICB9LFxuICAgIGNvbXBvbmVudFdpbGxSZWNlaXZlUHJvcHMocHJvcHMpIHtcbiAgICAgIHJldHVybiB3aWxsUmVjZWl2ZVByb3BzKHByb3BzLCB0aGlzLnByb3BzKVxuICAgIH0sXG4gIH0pXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/containers/util/willReceiveProps.js
// module id = 852
// module chunks = 0